requirejs(['app'], function(app){
    console.log('%cfile: common.js', 'color: #C2ECFF');

    new app();
});

define("common", function(){});

